import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Modal from '~/Common-Objects/Modal/index'
import SelectNewDefault from '~/Common-Objects/UI/Select/Default'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import TierLimitHolder from '~/Common-Objects/UI/Cards/TierLimitHolder'
import axios from '~/data/http/axios'
import i18n from '~/i18n'
import postHogFunctions from '~/Classes/posthog'
import TierPermissions from '~/Classes/tierPermissions'

import './index.scss'

const InviteStaffModal = ({ onClose }) => {
    const [emailAddress, setEmailAddress] = useState('')
    const [inputErrors, setInputErrors] = useState('')
    const [userCount, setUserCount] = useState(0)
    const [roles, setRoles] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedRole, setSelectedRole] = useState(null)
    const account = useSelector((state) => state.accountMaster)

    const userPermissions = TierPermissions('users', account)

    useEffect(() => {
        axios
            .get('/role')
            .then((response) => {
                if (response.data.Roles.length > 0) {
                    setRoles(response.data.Roles)
                    setSelectedRole(response.data.Roles[0].id)
                    setLoading(false)
                }
            })
            .catch((err) => console.log(err))
    }, [])

    useEffect(() => {
        axios.get('/accountMaster/users').then((usersData) => {
            setUserCount(usersData.data.Users.length)
        })
    }, [])

    const handleClick = async (role) => {
        if (!emailAddress.trim() || !selectedRole) return
        try {
            const data = { emailAddress: emailAddress.trim(), RoleId: selectedRole }
            await axios.post('/accountMaster/register', data)
            postHogFunctions.capture('added_user')
            onClose()
        } catch (error) {
            console.error(error)
            setInputErrors(error.response.data.Errors)
        }
    }

    return (
        <Modal
            width='540px'
            noClickAway={true}
            top={false}
            blurBg={true}
            noScroll={true}
            closeButton={false}
            onCloseButton={onClose}
        >
            <h2 className={'invite-staff-modal__title'}>{i18n.t('company:staff.inviteTeammate')}</h2>
            <p className={'invite-staff-modal__subTitle'}>{i18n.t('company:staff.inviteTeammateSubHeader')}</p>
            <div className={'invite-staff-modal__content'}>
                {userPermissions && userPermissions.limit > 0 && userCount >= userPermissions.limit ? (
                    <TierLimitHolder
                        type={'user'}
                        err={'tierOverLimit'}
                        allowedNumber={userPermissions.limit}
                        tierName={userPermissions.tierName}
                    />
                ) : loading ? (
                    <LoadingIcons iconType='2' />
                ) : (
                    <div className={'invite-staff-modal__form'}>
                        <div className={'invite-staff-modal__inputs'}>
                            <TextInput
                                label={i18n.t('emailAddress')}
                                focus={true}
                                type='text'
                                placeholder={i18n.t('emailAddressPlaceholder')}
                                name='emailAddress'
                                error={inputErrors}
                                value={emailAddress}
                                onChange={(e) => setEmailAddress(e.currentTarget.value)}
                            />
                            {roles.length > 1 && (
                                <SelectNewDefault
                                    label='Role'
                                    value={selectedRole}
                                    data={roles.map((r) => ({ label: r.name, value: r.id }))}
                                    onValueChange={(val) => setSelectedRole(val)}
                                    className='invite-staff-modal__inputs-select'
                                />
                            )}
                        </div>
                        <div className={'invite-staff-modal__buttons'}>
                            <Button
                                text={i18n.t('company:staff.inviteTeammateButton')}
                                iconRight={<Icons icon='arrowRight' />}
                                className='button-primary'
                                onClick={handleClick}
                            />
                            <Button text={i18n.t('cancel')} className='button-ghost' onClick={onClose} />
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    )
}

export default InviteStaffModal
